// Filename: router.js
define(
    'mainRouter',[
        'loader',
        'config',
        'sandbox',
        'helper',

        'views/global.view',

        'models/global.model'
    ],
    function(Loader, Config, Sandbox, Helper, GlobalView, GlobalModel)
    {
        var AppRouter = Loader.Backbone.Router.extend({

            routes: {
                '*actions': 'defaultAction'
            },

            views:
            {
                global: false
            },

            GlobalModel: new GlobalModel,

            showWeb: function()
            {
                if (this.views.global) return;

                var _this = this;
                this.GlobalModel.setUserConfigs(function(){
                    _this.views.global = GlobalView.initialize(_this.GlobalModel);
                    _this.views.global.render();
                    _this.GlobalModel.trigger('startApplication');
                });
            },

            defaultAction: function(actions) {
                this.showWeb();
            }
        });

        return {
            obj: new AppRouter,

            init: function()
            {
                Loader.Backbone.history.start();
            },
            navigate: function(url)
            {
                this.obj.navigate(url, {trigger: true, replace: true});
            }
        };
    }
);

